import React from "react";
import BudgetCard from "./BudgetCard";
import { useSelector, useDispatch } from "react-redux";
import { CATEGORIES } from "../helpers";
import { BudgetSection, BudgetDiv } from "../styling/BudgetStyles";

function BudgetsOverview() {
    const budgets = useSelector(state => state.budgets)
    const dispatch = useDispatch()

    return (
        <BudgetSection>
            <h2 style={{marginTop: '0'}}>Budgets</h2>
            <BudgetDiv>
                {CATEGORIES.map(category => (
                    <BudgetCard name={category} amount={budgets[category]} dispatch={dispatch} key={category} />
                ))}
                
            </BudgetDiv>
        </BudgetSection>
    )
}

export default BudgetsOverview;